import NextJSInstall from "../../../../contents/docs/integrate/_snippets/nextjs/install-nextjs.mdx";
import Tab from "components/Tab";
import AppRouterErrorTracking from "../../../../contents/docs/error-tracking/installation/_snippets/nextjs-router-snippets/app-router.mdx";
import PagesRouterErrorTracking from "../../../../contents/docs/error-tracking/installation/_snippets/nextjs-router-snippets/page-router.mdx";
import JSWebErrorTracking from "../../../../contents/docs/error-tracking/_snippets/web-install-error-tracking.mdx";
import InstallNodePackageManagers from "../../../../contents/docs/integrate/_snippets/install-node-package-managers.mdx";
import StepVerifyErrorTracking from "../../../../contents/docs/error-tracking/installation/_snippets/step-verify-error-tracking.mdx";
import StepUploadSourceMaps from "../../../../contents/docs/error-tracking/installation/_snippets/step-upload-source-maps.tsx";
import * as React from 'react';
export default {
  NextJSInstall,
  Tab,
  AppRouterErrorTracking,
  PagesRouterErrorTracking,
  JSWebErrorTracking,
  InstallNodePackageManagers,
  StepVerifyErrorTracking,
  StepUploadSourceMaps,
  React
};